<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span>Action Status Template</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-list shaped>
                        <v-list-item-group v-model="model" multiple>
                            <template v-for="status in allRouteStatuses">
                                <v-list-item
                                    :key="status.id"
                                    :value="status"
                                    active-class="deep-purple--text text--accent-4"
                                >
                                    <template v-slot:default="{ active }">
                                        <v-list-item-content>
                                            <v-list-item-title
                                                v-text="status.name"
                                            ></v-list-item-title>
                                        </v-list-item-content>
                                        {{
                                            computedOrderNumber(
                                                model.filter(
                                                    (m) => m.id === status.id
                                                )
                                            )
                                        }}
                                        <v-list-item-action>
                                            <v-checkbox
                                                :input-value="active"
                                                color="deep-purple accent-4"
                                            ></v-checkbox>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                            </template>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="accessFrom != 'route'"
                        color="blue darken-1"
                        text
                        @click="close(true)"
                    >
                        Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save()">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import Swal from "sweetalert2";
    import { mapActions, mapGetters } from "vuex";

    export default {
        name: "ActionTemplatesDialog",
        props: {
            dialog: Boolean,
            dialog2: Boolean,
            action: Object,
            accessFrom: String,
        },
        data: () => ({
            items: ["Dog Photos", "Cat Photos", "", "Potatoes", "Carrots"],
            model: [],
        }),
        methods: {
            ...mapActions([
                "fetchRouteStatuses",
                "createActionTemplate",
                "fetchActionTemplate",
            ]),
            save() {
                const body = {
                    action_id: this.action.id,
                    statuses: this.model,
                };

                if (this.accessFrom != "route") {
                    this.createActionTemplate(body).then(() => {
                        Swal.fire(
                            "Saved!",
                            "Action template created",
                            "success"
                        );
                    });
                } else {
                    if (this.model.length < 1) {
                        Swal.fire(
                            "Route Statuses Required!",
                            "Please select route statuses for this receiver",
                            "error"
                        );
                    }
                }
                this.close(body);
            },
            close(body) {
                this.$emit("closeDialog", body);
            },
            computedOrderNumber(idx) {
                return idx[0] ? idx[0].order_number : "";
            },
        },
        computed: {
            ...mapGetters(["allRouteStatuses", "allActionTemplates"]),
        },
        watch: {
            dialog() {
                if (this.dialog) {
                    if (this.allRouteStatuses.length < 1) {
                        this.fetchRouteStatuses();
                    }

                    let index = this.allActionTemplates.findIndex(
                        (template) => template.action_id === this.action.id
                    );

                    if (index == -1) {
                        // fetch its model
                        this.fetchActionTemplate(this.action.id).then(() => {
                            let index2 = this.allActionTemplates.findIndex(
                                (template) =>
                                    template.action_id == this.action.id
                            );
                            let setModels = [];
                            this.allActionTemplates[index2].statuses.forEach(
                                (template) => {
                                    const findTemp = this.allRouteStatuses.find(
                                        (status) => status.id == template.id
                                    );
                                    findTemp.order_number =
                                        template.order_number;
                                    setModels.push(findTemp);
                                }
                            );
                            this.model = setModels;
                        });
                    } else {
                        let index2 = this.allActionTemplates.findIndex(
                            (template) => template.action_id == this.action.id
                        );
                        let setModels = [];
                        this.allActionTemplates[index2].statuses.forEach(
                            (template) => {
                                const findTemp = this.allRouteStatuses.find(
                                    (status) => status.id == template.id
                                );
                                findTemp.order_number = template.order_number;
                                setModels.push(findTemp);
                            }
                        );
                        this.model = setModels;

                        // this.model = this.allActionTemplates[index].statuses;
                    }
                }
            },
            model: function() {
                this.model.forEach((e, idx) => {
                    e.order_number = idx + 1;
                });
            },
            dialog2() {
                if (this.dialog2) {
                    if (this.allRouteStatuses.length < 1) {
                        this.fetchRouteStatuses();
                    }

                    let index = this.allActionTemplates.findIndex(
                        (template) => template.action_id === this.action.id
                    );

                    if (index == -1) {
                        // fetch its model
                        this.fetchActionTemplate(this.action.id).then(() => {
                            let index2 = this.allActionTemplates.findIndex(
                                (template) =>
                                    template.action_id == this.action.id
                            );
                            let setModels = [];
                            this.allActionTemplates[index2].statuses.forEach(
                                (template) => {
                                    const findTemp = this.allRouteStatuses.find(
                                        (status) => status.id == template.id
                                    );
                                    findTemp.order_number =
                                        template.order_number;
                                    setModels.push(findTemp);
                                }
                            );
                            this.model = setModels;
							this.save();
                        });
                    } else {
                        let index2 = this.allActionTemplates.findIndex(
                            (template) => template.action_id == this.action.id
                        );
                        let setModels = [];
                        this.allActionTemplates[index2].statuses.forEach(
                            (template) => {
                                const findTemp = this.allRouteStatuses.find(
                                    (status) => status.id == template.id
                                );
                                findTemp.order_number = template.order_number;
                                setModels.push(findTemp);
                            }
                        );
                        this.model = setModels;
						this.save();
                    }
                    
                }
            },
        },
    };
</script>

<style></style>
